import { useQuery } from "@tanstack/react-query";
import Seo from "@/components/Seo";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { MarketCards } from "@/components/MarketCards";
import { RateBoard } from "@/components/RateBoard";
import { ParsianBoard } from "@/components/ParsianBoard";
import { Manifesto } from "@/components/Manifesto";
import { AboutNews } from "@/components/AboutNews";
import { Contact } from "@/components/Contact";
import { SocialDock } from "@/components/SocialDock";
import { InstallPrompt } from "@/components/InstallPrompt";
import { OfflineBadge } from "@/components/OfflineBadge";
import { Footer } from "@/components/Footer";
import { getBoard, getHistory } from "@/lib/api";

export default function Home() {
  const { data: board } = useQuery({
    queryKey: ["board"],
    queryFn: getBoard,
    refetchInterval: 30000,
  });
  const { data: history } = useQuery({
    queryKey: ["history"],
    queryFn: getHistory,
    refetchInterval: 60000,
  });

  return (
    <div data-testid="home-page" className="relative min-h-screen bg-[#0a0a0c] text-stone-100">
      <Seo
        title="سکه کازرانی | تابلوی نرخ روز سکه و طلا"
        siteName="سکه کازرانی"
        description="استعلام آنلاین نرخ روز سکه امامی، بهار آزادی، نیم، ربع و گرمی، سکه‌های پارسیان و شاخص‌های بازار طلا — مغازه سکه و طلای کازرانی، تهران، خیابان ولیعصر."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Store",
          name: "سکه کازرانی",
          telephone: "+982188977824",
          address: {
            "@type": "PostalAddress",
            streetAddress: "خیابان ولیعصر، بین تقاطع فاطمی و یوسف‌آباد، پلاک ۱۹۶۴",
            addressLocality: "تهران",
            addressCountry: "IR",
          },
        }}
      />
      <div className="grain-overlay" />
      <Header />
      <OfflineBadge board={board} className="fixed left-4 top-20 z-40 shadow-lg" />
      <main>
        <Hero board={board} />
        <Marquee />
        <MarketCards items={board?.market} history={history} />
        <RateBoard coins={board?.coins} updatedAt={board?.updated_at} history={history} market={board?.market} />
        <ParsianBoard items={board?.parsian} />
        <Manifesto />
        <AboutNews news={board?.news} />
        <Contact />
      </main>
      <Footer />
      <SocialDock />
      <InstallPrompt />
    </div>
  );
}
